import React, { useEffect, useState, Fragment } from "react";
import { Route, Switch, useRouteMatch, BrowserRouter } from "react-router-dom";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import SignInBySchool from "./SignInBySchool";
import LoginRegistrationPagePartner from "./Components/Partner/LoginRegistrationPage";
import LoginRegistrationPageClasic from "./Components/Clasic/LoginRegistrationPage";
import { useSelector, connect, useDispatch } from "react-redux";
import { validateAccessUser } from "../../services/utils";
import { RouterPathApp } from "../../components/routers/RoutesPathApp";
import { getSchoolDetails } from "../../redux/actions/schoolsActions";
import { authSuccess } from "../../redux/actions/authActions";
import { getMe } from "../../api/authApi";

const SignInBySchoolSwitch = (props) => {
  const [typeSchool, setTypeSchool] = useState("");
  const [isCheckingCookies, setIsCheckingCookies] = useState(true);
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const { school, getDetails, history } = props;
  const authState = useSelector((state) => state.auth);
  const isAuthenticated = authState?.data?.user;

  // Define processUrl before it's used in useEffect
  const processUrl = () => {
    if (match.params) {
      const { schoolName } = match.params;
      if (schoolName === "classic") {
        setTypeSchool("classic");
      } else {
        getDetails(schoolName, history);
      }
    }
  };

  // On mount, try to restore session from backend (only once)
  useEffect(() => {
    getMe({ credentials: 'include' })
      .then(response => {
        if (response?.data) {
          dispatch(authSuccess({ data: { user: response.data }, token: null }));
        }
      })
      .catch(() => {
        // No valid session - show login form
      })
      .finally(() => {
        setIsCheckingCookies(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    processUrl();
  }, []);

  useEffect(() => {
    if (school.hasOwnProperty("dataDetails"))
      if (school.dataDetails.hasOwnProperty("partnershipLevel")) {
        setTypeSchool(school.dataDetails.partnershipLevel);
      }
  }, [school]);

  // Redirect to home if already authenticated (check Redux state only)
  useEffect(() => {
    if (isAuthenticated) {
      history.replace('/home');
    }
  }, [isAuthenticated, history]);

  // Show loading while checking cookies
  if (isCheckingCookies) {
    return null;
  }

  // Don't render if already authenticated
  if (isAuthenticated) {
    return null;
  }

  return (
    <Fragment>
      {typeSchool === "inclusive" && <SignInBySchool {...props} />}
      {typeSchool === "partner" && <LoginRegistrationPagePartner {...props} />}
      {typeSchool === "classic" && <LoginRegistrationPageClasic {...props} />}
    </Fragment>
  );
};

SignInBySchoolSwitch.propTypes = {
  history: PropTypes.object,
};

const mapStateToProps = (state) => ({
  school: state.school,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDetails: (schoolName, history) =>
      dispatch(getSchoolDetails({ name: schoolName, history })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignInBySchoolSwitch);
